<template>
  <div id="map-indicator" />
</template>

<script>
import L from 'leaflet'
import { getMapParent } from '@/utils/utils'

export default {
  name: 'MapIndicator',
  props: {
    coordinates: {
      type: Array,
      required: true
    },
    popupContent: {
      type: String
    },
    color: {
      type: String,
      default: 'black'
    },
    markerOptions: {
      type: Object
    },
    hidden: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: true
    },
    radius: {
      type: Number,
      default: 5
    }
  },
  data () {
    return {
      map: null,
      indicator: null
    }
  },
  watch: {
    hidden () {
      this.onHiddenChange()
      this.onBorderedChange()
    },
    bordered () {
      this.onBorderedChange()
    }
  },
  created () {
    this.map = getMapParent(this.$parent).map

    this.indicator = L.circle(this.coordinates, {
      opacity: 0.75,
      color: this.color,
      radius: this.radius
    })
      .on('mouseover', (e) => { e.target.openPopup() })
      .on('mouseout', (e) => { e.target.closePopup() })
      .on('click', () => { this.$emit('click') })
      .on('add', (e) => {
        // Accessibility changes
        e.target._path.tabIndex = 0
        e.target._path.setAttribute('role', 'button')
        e.target._path.setAttribute('aria-label', `${this.popupContent}`)

        // Add keyboard submission support
        e.target._path.addEventListener('keypress', (keyE) => {
          this.$emit('click', keyE)
        })
      })

    if (this.popupContent) {
      const popup = L.popup()
        .setContent(this.popupContent)

      this.indicator.bindPopup(popup)
    }

    this.onHiddenChange()

    this.$emit('ready', this.map)
  },
  mounted () {
    this.onBorderedChange()
  },
  beforeDestroy () {
    this.map.removeLayer(this.indicator)
  },
  methods: {
    onHiddenChange () {
      if (this.hidden) {
        this.map.removeLayer(this.indicator)
      } else {
        this.map.addLayer(this.indicator)
      }
    },
    onBorderedChange () {
      const indicatorElement = this.indicator.getElement()

      if (indicatorElement) {
        if (this.bordered) {
          indicatorElement.style.stroke = this.color
        } else {
          indicatorElement.style.stroke = 'transparent'
        }
      }
    }
  }
}
</script>
